import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20wavy%20texture%20with%20deep%20purple%20black%20gradient%2C%20mysterious%20atmosphere%2C%20subtle%20ripple%20patterns%2C%20dark%20void%20with%20red%20undertones%2C%20minimalist%20yet%20dramatic%2C%20no%20text%2C%20no%20people%2C%20dark%20ambient%20background%2C%20cyber%20noir%20aesthetic&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料718 实时吃瓜黑料追踪站背景"
          className="w-full h-full object-cover object-top"
          title="黑料718 实时吃瓜黑料追踪站"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="flex items-center space-x-2 mb-6">
            <span className="px-3 py-1 bg-primary-500/20 border border-primary-500/30 rounded-full text-primary-400 text-xs font-medium">
              实时追踪
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-foreground-400 text-xs">24小时更新中</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl font-black text-foreground-50 leading-tight mb-4">
            全网吃瓜
            <br />
            只在<span className="text-primary-400">黑料718</span>
          </h1>
          <p className="text-foreground-400/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            整合黑料718官网、入口、APP下载及最新地址。网红塌房、明星聊天记录泄露、博主反差视频 —— 一手爆料，实时追踪。
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
            <Link
              to="/category/wanghong-tafang"
              className="px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <span>立即吃瓜</span>
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 border border-foreground-300/30 text-foreground-300 text-sm font-medium rounded-full hover:border-foreground-300/60 hover:text-foreground-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              APP下载
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}